export const checkSentiment = {
  data () {
    return {
      MX_newMsg: '',
      MX_space: 1,
      MX_initial: false,
      MX_lastMsg: '',
    }
  },
  watch: {
    MX_newMsg (val) {
      if (!val || val === '') {
        this.nlp = 'positive';
        this.MX_space = 0;
      }
    }
  },
  beforeDestroy () {
    this.MX_space = 0;
    this.MX_newMsg = '';
  },
  methods: {
    MX_checkNLP() {
      if (this.MX_space === 2) {
        this.MX_initial = true;
        this.MX_lastMsg = '';
      } else if (this.MX_space > 2) {
        this.MX_initial = false;
      }

      if (this.MX_space === 2 && this.MX_initial) {
        this.MX_postNLP();
      } else if (this.MX_space > 2 && !this.MX_initial) {
        this.MX_postNLP();
      }
      this.MX_space++;
    },
    MX_checkNlpOnDiscussion () {
      if (this.MX_space === 2 && this.MX_newMsg.replace(/\s/g, '').length) {
        this.MX_initial = true;
      } else if (this.MX_space > 2) {
        this.MX_initial = false;
      }

      if (this.MX_space === 2 && this.MX_newMsg.replace(/\s/g, '').length && this.MX_initial) {
        this.MX_postNLP();
      } else if (this.MX_space > 2 && !this.MX_initial) {
        this.MX_postNLP();
      }
      this.MX_space++;
    },
    MX_postNLP() {
      if (this.MX_newMsg.trim() !== '' && this.MX_lastMsg.trim() !== this.MX_newMsg.trim()) {
        this.postNlpScore({
          text: this.MX_newMsg
        })
        .then(response => {
          this.nlp = response.data.data.sentiment.toLowerCase();
          this.MX_lastMsg = this.MX_newMsg;
        })
        .catch(error => {
          if ((error.response.status !== 406 && error.response.status !== 401 && error.response.status !== 402) && error.response.status !== 429) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
          if (error.response.status === 429) {
            this.nlp = 'positive'
          }
        })
      }
    },
  }
};
